import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const websocketStore = useWebsocketStore()
  const chatStore = useChatStore()
  const { apiRootUrl } = useRuntimeConfig().public

  // Keep track of subscribed channels
  const subscribedChannels = new Set()

  // Subscribe to all user channels when channels are loaded
  watch(
    () => chatStore.channels,
    (newChannels) => {
      if (newChannels && newChannels.length > 0) {
        subscribeToAllChannels(newChannels)
      }
    },
    { deep: true }
  )

  if (process.client) {
    window.Pusher = Pusher

    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'pgdox3h7rm74luaxhzqx',
      cluster: 'eu',
      authEndpoint: `${apiRootUrl}broadcasting/auth`,
      wsHost: 'ws.1tool.com',
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      bearerToken: userStore.user.api_token,
      enabledTransports: ['ws', 'wss']
    })

    window.Echo.connector.pusher.connection.bind('connected', () => {
      const socketId = window.Echo.socketId()
      websocketStore.setSocketId(socketId)

      // Initialize channel subscriptions when websocket connects
      setTimeout(() => {
        if (userStore.user?.id) {
          initializeChannelSubscriptions()
        }
      }, 1000) // Small delay to ensure user store is ready
    })
  }

  function subscribeToAllChannels(channels) {
    channels.forEach((channel) => {
      const channelId = channel.id
      if (!subscribedChannels.has(channelId)) {
        createChatChannel(channelId)
        subscribedChannels.add(channelId)
      }
    })
  }

  function createChatChannel(channelId) {
    const channelName = `chat.${userStore.user.tenant_identifier}.${channelId}`

    window.Echo.private(channelName).listen('.NewMessage', (event) => {
      chatStore.addMessage(event.message, true)
    })
  }

  // Subscribe to channels when user logs in and websocket connects
  function initializeChannelSubscriptions() {
    if (window.Echo && userStore.user?.id) {
      // Load channels and subscribe to them
      chatStore.loadChannels().then()
    }
  }

  // Expose initialization function globally for manual triggering
  if (process.client) {
    window.initializeChatSubscriptions = initializeChannelSubscriptions
  }
})
